import { SignUp as ClerkSignUp } from "@clerk/clerk-react";
import { AuthSidebar } from "../components/auth/AuthSidebar";
import { clerkLogoImageUrl } from "../branding/themeAssets";

export enum SignupSource {
  signupPage = "signup-page",
  firmInvite = "firm-invite",
  externalInvite = "external-invite",
  sellerSignup = "seller-signup",
}

interface SignupLayoutProps {
  leftContent: React.ReactNode;
  rightContent: React.ReactNode;
}

function SignupLayout({ leftContent, rightContent }: SignupLayoutProps) {
  return (
    <div className="flex h-screen flex-1 bg-concrete-50">
      {leftContent}
      <div className="flex flex-1 flex-col justify-center items-center gap-y-4">
        {rightContent}
      </div>
    </div>
  );
}

export function Signup() {
  return (
    <SignupLayout
      leftContent={<AuthSidebar />}
      rightContent={
        <ClerkSignUp
          appearance={{
            layout: {
              socialButtonsPlacement: "bottom",
              logoImageUrl: clerkLogoImageUrl(),
            },
          }}
          unsafeMetadata={{
            onboardingStatus: "initial",
            signupSource: SignupSource.signupPage,
          }}
          signInUrl="/login"
        />
      }
    />
  );
}

export function SellerSignup() {
  return (
    <SignupLayout
      leftContent={<AuthSidebar variant="seller" />}
      rightContent={
        <ClerkSignUp
          appearance={{
            layout: {
              socialButtonsPlacement: "bottom",
              logoImageUrl: clerkLogoImageUrl(),
            },
          }}
          unsafeMetadata={{
            onboardingStatus: "initial",
            signupSource: SignupSource.sellerSignup,
          }}
          signInUrl="/login"
        />
      }
    />
  );
}
